import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'hs_session_v1';

function readSessionFromSessionStorage() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== 'object') return null;
    const sessionId = p.sessionId != null ? String(p.sessionId).trim() : '';
    const organizationId = p.organizationId != null ? String(p.organizationId).trim() : '';
    if (!sessionId || !organizationId) return null;
    const adminToken = `${sessionId}&${organizationId}`;
    return { adminToken, sessionId, organizationId };
  } catch {
    return null;
  }
}

function writeSessionToSessionStorage({ sessionId, organizationId }) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ sessionId, organizationId })
    );
  } catch {
    /* ignore */
  }
}

function clearSessionFromSessionStorage() {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

const initialState =
  readSessionFromSessionStorage() || { adminToken: null, sessionId: null, organizationId: null };

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, { payload }) => {
      const { sessionId, organizationId } = payload;
      const adminToken = `${sessionId}&${organizationId}`;
      // update Redux state
      state.adminToken = adminToken;
      state.sessionId = sessionId;
      state.organizationId = organizationId;
      writeSessionToSessionStorage({ sessionId, organizationId });
    },
    clearSession: (state) => {
      state.adminToken = null;
      state.sessionId = null;
      state.organizationId = null;
      clearSessionFromSessionStorage();
    },
  },
});

export const { setSession, clearSession } = sessionSlice.actions;
export default sessionSlice.reducer;

// Selectors for use with useSelector(...)
export const selectAdminToken = (state) => state.session.adminToken;
export const selectSessionId = (state) => state.session.sessionId;
export const selectOrganizationId = (state) => state.session.organizationId;

// NOTE: localStorage is intentionally not used.
